/**
 * Roles the backend answers onboarding requests for.
 *
 * Every onboarding endpoint, `GET /onboarding/state` included, is
 * `@Roles('owner', 'admin')`. Anyone else asking gets a 403 per attempt — three
 * of them under the client's `retry: 2`, each one a Sentry capture. Keeping the
 * list here means the client's idea of who may ask cannot drift away from the
 * guard's in one screen while another still asks.
 */
const ONBOARDING_STATE_ROLES = new Set(['owner', 'admin']);

/** False while the role is still unknown: silence beats a forbidden request. */
export function canReadOnboardingState(role: string | undefined): boolean {
  return !!role && ONBOARDING_STATE_ROLES.has(role);
}
